import { Paper, Typography } from '@mui/material';
import { get } from 'lodash';
import React, { FC } from 'react';
import MarkdownRenderer from '../../../../../components/ui-component/markdown-renderer/MarkdownRenderer';
import { useFoerderProgramm } from '../../../../../context/FoerderProgrammContext';

// import schemas
import FoerderRichtlinieSchema from 'src/lib/paths/foerderrichtlinie_DETAILS_SEITE_Paths.json';
let FR_P = FoerderRichtlinieSchema.attributes;

const ProgrammBeschreibungSection: FC<{}> = () => {
	const { foerderRichtlinieDetails } = useFoerderProgramm();

	return (
		<>
			<Paper sx={{ p: '2rem' }}>
				<Typography component={'div'} sx={{ mt: -2 }}>
					<MarkdownRenderer markdown={get(foerderRichtlinieDetails, FR_P.Allgemein_Langbeschreibung.path, '')} />
				</Typography>
			</Paper>
		</>
	);
};

export default ProgrammBeschreibungSection;
